import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IProvideCssDefinition } from '@wix/viewer-service-provide-css/definition'
import { ProvideCssDefinition as definition } from '@wix/viewer-service-provide-css/definition'
import { ProvideCssService as impl } from '@wix/viewer-service-provide-css/implementations'

export const provideCssService: FactoryWithDependencies<ServiceProvider<IProvideCssDefinition, typeof impl>> =
	withDependencies([], (): ServiceProvider<IProvideCssDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: {},
		}
	})
